import { supabase } from "@/lib/supabaseClient";

export async function getCurrentUserIdOrThrow(): Promise<string> {
  if (!supabase) {
    throw new Error("Supabase is not configured.");
  }

  const { data: sessionData, error: sessionError } = await supabase.auth.getSession();

  if (sessionError) {
    console.error("[AUTH_GET_SESSION_ERROR]", sessionError);
  }

  const sessionUserId = sessionData?.session?.user?.id;

  if (sessionUserId) {
    return sessionUserId;
  }

  const { data: userData, error: userError } = await supabase.auth.getUser();

  if (userError) {
    console.error("[AUTH_GET_USER_ERROR]", userError);
  }

  const userId = userData?.user?.id;

  if (!userId) {
    console.error("[AUTH_USER_NOT_FOUND]", {
      hasSession: Boolean(sessionData?.session),
      sessionError,
      userError,
    });

    throw new Error("Usuário não autenticado.");
  }

  return userId;
}
